import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ResultLayout from '../screens/ResultLayout';
import ResultDashboard from '../screens/ResultDashboard';
import RegionDrillDown from '../screens/RegionDrillDown';
import SchoolDrillDown from '../screens/SchoolDrillDown';
import StudentResultDetail from '../screens/StudentResultDetail';
import ClassificationAnalysis from '../screens/ClassificationAnalysis';
import SubjectWiseAnalysis from '../screens/SubjectWiseAnalysis';
import YearwiseAnalysis from '../screens/YearwiseAnalysis';
import ComparisonAnalysis from '../screens/ComparisonAnalysis';

const ResultRoutes: React.FC = () => (
  <Routes>
    <Route element={<ResultLayout />}>
      {/* Class 10 and 12 Comparison */}
      <Route path="comparison" element={<ComparisonAnalysis />} />
      {/* Classification Analysis — default page */}
      <Route index element={<ClassificationAnalysis />} />

      {/* National Overview */}
      <Route path="overview" element={<ResultDashboard />} />

      {/* Classification Analysis (named path kept for backward compatibility) */}
      <Route path="classification" element={<ClassificationAnalysis />} />

      {/* Subject-wise Analysis */}
      <Route path="subject-analysis" element={<SubjectWiseAnalysis />} />

      {/* Year-wise Analysis */}
      <Route path="yearwise-analysis" element={<YearwiseAnalysis />} />

      {/* Layered Drill-down */}
      <Route path="region/:regionCode" element={<RegionDrillDown />} />
      <Route path="region/:regionCode/school/:kvCode" element={<SchoolDrillDown />} />
      <Route path="region/:regionCode/school/:kvCode/student/:rollNo" element={<StudentResultDetail />} />
    </Route>
  </Routes>
);

export default ResultRoutes;